var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "d-flex flex-column ga-4",
      attrs: { "data-qa": "service_types" },
    },
    _vm._l(_vm.serviceTypes, function ({ name, href, price }) {
      return _c(
        "a",
        {
          key: name,
          staticClass:
            "service-type d-flex text-body-1 text--text text-decoration-none",
          attrs: { "data-qa": "service_type", href: href },
        },
        [
          _c(
            "div",
            {
              staticClass: "mr-auto",
              attrs: { "data-qa": "service_type_name" },
            },
            [_vm._v("\n      " + _vm._s(name) + "\n    ")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "ml-2 text-no-wrap primary--text" }, [
            _vm._v("\n      от "),
            _c("span", { attrs: { "data-qa": "service_type_price" } }, [
              _vm._v(_vm._s(price)),
            ]),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }